"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlags = void 0;
const flagsOrder = [
    // Insert new flag in this line.
    'travelEnabled',
    'subCompaniesEnabled',
    'customCsvTemplatesEnabled',
    'costCenterGroupsEnabled',
    'outgoingWireTransferEnabled',
    'stripeEnabled',
    'paidVersion',
];
// Type guard so if this returns true, typescript knows that the object being tested is a FeatureFlagsInterface
// https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates
const isFeatureFlagsObject = (object) => {
    if (!(object instanceof Object))
        return false;
    for (const flagName of flagsOrder) {
        if (!(flagName in object))
            return false;
    }
    return true;
};
class FeatureFlags {
    constructor(data) {
        if (isFeatureFlagsObject(data)) {
            flagsOrder.forEach((flag) => {
                this[flag] = data[flag];
            });
        }
        else {
            let binaryString = data.toString(2);
            // binary string needs padding to keep order consistent
            binaryString = '0'.repeat(flagsOrder.length - binaryString.length) + binaryString;
            flagsOrder.forEach((flag, i) => {
                this[flag] = Boolean(Number(binaryString.charAt(i)));
            });
        }
    }
    /**
     * Gets the plain feature flags object
     */
    getFlagsObject() {
        return Object.assign({}, this);
    }
    /**
     * Gets the number aqcuired from the bits that are made from the booleans of feature flags
     */
    getBitflagsNumber() {
        const flagsNumberValue = Number.parseInt(this.getBinary(), 2);
        return flagsNumberValue;
    }
    /**
     * Gets the binary string from the feature flags
     */
    getBinary() {
        return flagsOrder.map((flag) => Number(this[flag])).join('');
    }
}
exports.FeatureFlags = FeatureFlags;
